import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import UserMenu from './UserMenu';

const SidebarFooter = ({ 
    user, 
    token, 
    isUserMenuOpen,
    onToggleUserMenu,
    onLogin, 
    onLogout, 
    onGoSubscriptions 
}) => {
    const { t } = useTranslation();

    const handleToggleMenu = useCallback((e) => {
        e.stopPropagation();
        onToggleUserMenu();
    }, [onToggleUserMenu]);

    const handleLogin = useCallback(() => {
        onLogin();
    }, [onLogin]);

    return (
        <div className="sidebar-footer">
            <UserMenu
                isOpen={isUserMenuOpen && !!token && !!user}
                userEmail={user?.email_address}
                onUpgrade={onGoSubscriptions}
                onLogout={onLogout}
            />

            {token && user ? (
                <button
                    className="user-chat-info"
                    onClick={handleToggleMenu}
                    aria-expanded={isUserMenuOpen}
                    aria-haspopup="true"
                    aria-label="User menu"
                >
                    <span className="user-chat-avatar">
                        {user.first_name ? user.first_name.charAt(0).toUpperCase() : '👤'}
                    </span>
                    <div className='d-flex flex-column user-chat-names'>
                        <span className="user-chat-name">
                            {user.first_name || 'User'}
                        </span>
                    </div>
                    <span className='w-100 text-right' style={{ fontSize: '20px', color: '#ececf1' }}>
                        <i className="bi bi-three-dots-vertical"></i>
                    </span>
                </button>
            ) : (
                <div 
                    className='d-flex flex-row w-100 justify-content-between align-items-center my-2 cont-signin-buttons' 
                    onClick={handleLogin}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleLogin();
                        }
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="login-btn-chat text-left">{t('chat.sign_in',"Sign In")}</span>
                    <span className="chevron-login">
                        <i className="bi bi-chevron-right"></i>
                    </span>
                </div>
            )}
        </div>
    );
};

export default React.memo(SidebarFooter);